import React from 'react';
import style from './SaveChanges.scss'

const SaveChanges = (props) => {
    const {saving,SaveChanges} = props;
    const text = saving?"Saving Changes":"Save Changes";
    const span = saving?<span className={style.buttonLoad}>load</span>:"";
    return (
        <span className={style.buttonSave} onClick={SaveChanges}>
            {text}
            {span}
        </span>
    )
}

export default SaveChanges;
